import React, { Component } from 'react';
import { Tabs, Checkbox, message } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import ScoreChart from './com/ScoreLineChart';
import ScorePieChart from './com/ScorePieChart';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class testReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      lineData: [
        { value: 1, score: 0 },
        { value: 1.5, score: 0 },
        { value: 2, score: 0 },
        { value: 2.5, score: 10 },
        { value: 3, score: 120, index: true },
        { value: 3.5, score: 100 },
        { value: 4, score: 130 },
        { value: 4.5, score: 50 },
        { value: 5, score: 0 }
      ],
      pieData: [
        { name: "低分组", value: 20 },
        { name: "中分组", value: 15 },
        { name: "高分组", value: 10 },
      ]
    };

  }

  componentDidMount() {
    this.getUserInfo();

  }

  componentWillUnmount() {

  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status === 0) {
        this.setState({ user: res.result });
      }
    };
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });
  }



  render() {
    const { lineData, pieData } = this.state;
    return (
      <div component-data="testReport">
        <div className='screen'>
          <div className='head_filter'>
            <div className='box_1200'>
              <div className='head_title'>我的职业规划</div>
            </div>
          </div>

          <div className='mes_box box_1200' style={{ paddingTop: "105px" }}>
            <div className='report-box'>
              <div className='report-head'>
                <span className='report-title'> 主动性人格测试报告</span>
                <p className='report-time'>报告时间：2025.05.30 16:32</p>
                <span className='report-result'>您测试结果：30分</span>
                <div className='report-result-img'>
                  {1 === 1 ? (
                    <img src={require("../../img/pinzhunzhun/dataSource/top_ score.png")} alt="高分结果" />
                  ) : (
                    <img src={require("../../img/pinzhunzhun/dataSource/low_score.png")} alt="低分结果" />
                  )}
                </div>
              </div>

              <div className='report-content'>
                <div className='report-content-title'> <div className='report-title-order'>1</div> 测评结果</div>
                <div className='report-content-text'>
                  倾向于保守/低主动性。对变革、创新或主动行动的积极性较低，偏好稳定或常规模式。
                </div>

                <div className='report-content-title'> <div className='report-title-order'>2</div> 结果分析</div>

                <div style={{ display: 'flex' }}>
                  <div>
                    <ScoreChart chartData={lineData} />
                    <div className='lineChart_tips'> 
                  
                      <span className='line_tips_item'>低分组:10-30分</span>
                      <span className='line_tips_item'>中分组:40-60分</span>
                      <span className='line_tips_item'>高分组:60-100分</span>
                    </div>
                  </div>

                  <ScorePieChart chartData={pieData} />
                </div>
                <div className='analyse-tips'>
                  上图为所有参与本测试的人得分分布情况,会随参与人数的增加而变化.
                </div>

                <div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default testReport;  